import React, { memo } from "react";
import PropTypes from "prop-types";
import "./Loading.css";

/**
 * Loading component - Displays a loading spinner with optional message
 * @param {Object} props
 * @param {string} [props.message] - Optional loading message
 * @param {boolean} [props.fullscreen] - Whether to display fullscreen
 */
const Loading = memo(function Loading({
  message = "Loading...",
  fullscreen = false,
}) {
  const className = fullscreen ? "loading loading--fullscreen" : "loading";

  return (
    <div className={className}>
      <div className="loading__content">
        <div className="loading__spinner">
          <div className="loading__spinner-ring"></div>
          <div className="loading__spinner-ring"></div>
          <div className="loading__spinner-ring"></div>
        </div>
        {message && <p className="loading__message">{message}</p>}
      </div>
    </div>
  );
});

Loading.propTypes = {
  message: PropTypes.string,
  fullscreen: PropTypes.bool,
};

export default Loading;
